import styled from 'styled-components';

import { WarningAlertTriangleIcon } from '@assets/icons/WarningAlertTriangle';

export const WarningMessage = () => {
  return (
    <StyledContainer>
      <WarningAlertTriangleIcon />
      <p>
        Once booked, you can notify production and casting if you{"'"}re running
        late or need to cancel for an emergency. Note that{' '}
        <span>frequent cancellations may impact future bookings.</span>
      </p>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding: 11px 15px;
  display: flex;
  align-items: start;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.palette.stroke[1]};
  border-radius: 8px;

  p {
    margin: 0;
    span {
      font-weight: 600;
    }
    width: calc(100% - 32px);
  }

  @media (max-width: 960px) {
    padding: 11px;
  }
`;
